import React, { useEffect, useMemo, useState } from 'react'
import { CustomDataTableHeader, CustomPanel, PageHeader, Periodo } from '../../../../components'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import './StatusOperacoesLogisticas.css'
import useStatusOperacaoLogistica from './StatusOperacoesLogisticasHook'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import DashboardActions from '../../../../store/actions/dashboard.actions'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

function StatusOperacoesLogisticas({ history, dispatch, status, pInicial, pFinal }) {
  const { state, localDispatch } = useStatusOperacaoLogistica()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    if (state.statusOperacao.length > 0) {
      dispatch(
        DashboardActions.onPesquisarStatusOperacao(
          state.pInicial,
          state.pFinal,
          state.statusOperacao,
        ),
      )
      localDispatch.resetState()
    }
  }, [state.statusOperacao])

  useEffect(() => {
    if (status && status.length > 0) {
      localDispatch.setCondicoesIniciais(pInicial, pFinal, status)
    }
  }, [status])

  useEffect(() => {
    if (state.isLoading) {
      dispatch(showLoadingBox('Obtendo o Status das Operações Logísticas', 'Aguarde'))
    } else {
      dispatch(hideLoadingBox())
      localDispatch.resetState()
    }
  }, [state.isLoading])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Helper
  const styleHandler = useMemo(() => {
    return {
      getColumnStyle(width = 100) {
        return { ...tableCellCentered(width), padding: 0, position: 'relative' }
      },
    }
  }, [])

  // Render
  return (
    <>
      <PageHeader>1.1 - Status Operações Logísticas</PageHeader>
      <div style={{ marginTop: 16 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <Periodo
                periodoInicial={state.pInicial}
                periodoFinal={state.pFinal}
                onPesquisar={(pInicial, pFinal) =>
                  localDispatch.onBtnPesquisarClick(pInicial, pFinal)
                }
              />
            </div>

            {state.statusOperacao.length > 0 ? (
              <>
                <div className="p-col-6">
                  <h3 className="text-center">Pontuação Média</h3>
                  <ResponsiveContainer height={270} width="100%">
                    <PieChart>
                      <Pie data={state.pontuacaoMediaTotal}>
                        {state.pontuacaoMediaTotal.map(item => (
                          <Cell dataKey={item.value} key={item.name} fill={item.color} />
                        ))}
                      </Pie>
                      <Legend verticalAlign="bottom" layout="horizontal" align="center" />
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                <div className="p-col-6">
                  <h3 className="text-center">TOP 3 Melhores Operações</h3>
                  <ResponsiveContainer height={290} width="100%">
                    <BarChart
                      width={'100%'}
                      height={250}
                      data={state.rankingTP}
                      margin={{ top: 15, right: 30, left: 20, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="tp" />
                      <YAxis />
                      <Tooltip />
                      <Bar dataKey="pontuacao" fill={'#B1ECC1'} name={'Pontuação'} />
                    </BarChart>
                  </ResponsiveContainer>
                </div>

                <div className="p-col-2">
                  <h4 className="text-center">Picking</h4>
                  <ResponsiveContainer height={170} width="100%">
                    <PieChart>
                      <Pie data={state.pontuacaoMediaPicking}>
                        {state.pontuacaoMediaTotal.map(item => (
                          <Cell dataKey={item.value} key={item.name} fill={item.color} />
                        ))}
                      </Pie>
                      <Legend verticalAlign="bottom" layout="horizontal" align="center" />
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                <div className="p-col-2">
                  <h4 className="text-center">Resumo de Separação</h4>
                  <ResponsiveContainer height={170} width="100%">
                    <PieChart>
                      <Pie data={state.pontuacaoMediaResumoSeparacao}>
                        {state.pontuacaoMediaResumoSeparacao.map(item => (
                          <Cell dataKey={item.value} key={item.name} fill={item.color} />
                        ))}
                      </Pie>
                      <Legend verticalAlign="bottom" layout="horizontal" align="center" />
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                <div className="p-col-2">
                  <h4 className="text-center">Carregamento</h4>
                  <ResponsiveContainer height={170} width="100%">
                    <PieChart>
                      <Pie data={state.pontuacaoMediaCarregamento}>
                        {state.pontuacaoMediaCarregamento.map(item => (
                          <Cell dataKey={item.value} key={item.name} fill={item.color} />
                        ))}
                      </Pie>
                      <Legend verticalAlign="bottom" layout="horizontal" align="center" />
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                <div className="p-col-2">
                  <h4 className="text-center">Veículo Em Rota</h4>
                  <ResponsiveContainer height={170} width="100%">
                    <PieChart>
                      <Pie data={state.pontuacaoMediaVeiculoEmRota}>
                        {state.pontuacaoMediaVeiculoEmRota.map(item => (
                          <Cell dataKey={item.value} key={item.name} fill={item.color} />
                        ))}
                      </Pie>
                      <Legend verticalAlign="bottom" layout="horizontal" align="center" />
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                <div className="p-col-2">
                  <h4 className="text-center">Apuração Veículos de Entrega</h4>
                  <ResponsiveContainer height={170} width="100%">
                    <PieChart>
                      <Pie data={state.pontuacaoMediaApuracaoEntrega}>
                        {state.pontuacaoMediaApuracaoEntrega.map(item => (
                          <Cell dataKey={item.value} key={item.name} fill={item.color} />
                        ))}
                      </Pie>
                      <Legend verticalAlign="bottom" layout="horizontal" align="center" />
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                <div className="p-col-2">
                  <h4 className="text-center">Ordem Coleta - Devolução</h4>
                  <ResponsiveContainer height={170} width="100%">
                    <PieChart>
                      <Pie data={state.pontuacaoMediaOrdemColeta}>
                        {state.pontuacaoMediaOrdemColeta.map(item => (
                          <Cell dataKey={item.value} key={item.name} fill={item.color} />
                        ))}
                      </Pie>
                      <Legend verticalAlign="bottom" layout="horizontal" align="center" />
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </>
            ) : null}

            <div className="p-col-12 " style={{ marginTop: 16 }}>
              <DataTable
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
                value={state.statusOperacao}
                emptyMessage={'Selecione o Período para Apuração do Status das Operações'}
              >
                <Column field={'tp_name'} header={'Operação'} />
                <Column field={'total_real'} header={'Total'} style={tableCellCentered()} />
                <Column
                  header={'Picking'}
                  style={{ ...tableCellCentered(), padding: 0, position: 'relative' }}
                  body={item => (
                    <PontuacaoTableCell
                      meta={item.picking_meta}
                      real={item.picking_real}
                      onClick={() =>
                        history.push('/main/dashboard/status-operacoes-etapa-picking', {
                          etapa_picking_info: item.etapa_picking_info,
                        })
                      }
                    />
                  )}
                />
                <Column
                  header={'Resumo Separação'}
                  style={styleHandler.getColumnStyle()}
                  body={item => (
                    <PontuacaoTableCell
                      meta={item.resumo_separacao_meta}
                      real={item.resumo_separacao_real}
                      onClick={() =>
                        history.push('/main/dashboard/status-operacoes-etapa-resumo-separacao', {
                          etapa_resumo_separacao_info: item.etapa_resumo_separacao_info,
                        })
                      }
                    />
                  )}
                />
                <Column
                  header={'Carregamento'}
                  style={styleHandler.getColumnStyle(150)}
                  body={item => (
                    <PontuacaoTableCell
                      meta={item.carregamento_meta}
                      real={item.carregamento_real}
                      onClick={() =>
                        history.push('/main/dashboard/status-operacoes-etapa-carregamento', {
                          etapa_carregamento_info: item.etapa_carregamento_info,
                        })
                      }
                    />
                  )}
                />
                <Column
                  header={'Veículo em Rota'}
                  style={styleHandler.getColumnStyle()}
                  body={item => (
                    <PontuacaoTableCell
                      meta={item.veiculo_em_rota_meta}
                      real={item.veiculo_em_rota_real}
                      onClick={() =>
                        history.push('/main/dashboard/status-operacoes-etapa-envio-rota', {
                          etapa_envio_para_rota_info: item.etapa_envio_para_rota_info,
                        })
                      }
                    />
                  )}
                />
                <Column
                  header={'Apuração Entregas'}
                  style={styleHandler.getColumnStyle()}
                  body={item => (
                    <PontuacaoTableCell
                      meta={item.apuracao_entregas_meta}
                      real={item.apuracao_entregas_real}
                      onClick={() =>
                        history.push('/main/dashboard/status-operacoes-etapa-apuracao-entregas', {
                          etapa_apuracao_entrega_info: item.etapa_apuracao_entrega_info,
                        })
                      }
                    />
                  )}
                />
                <Column
                  header={'Ordem Coleta'}
                  style={styleHandler.getColumnStyle()}
                  body={item => (
                    <PontuacaoTableCell
                      meta={item.ordem_coleta_meta}
                      real={item.ordem_coleta_real}
                      onClick={() =>
                        history.push('/main/dashboard/status-operacoes-etapa-ordem-coleta', {
                          etapa_ordem_coleta_info: item.etapa_ordem_coleta_info,
                        })
                      }
                    />
                  )}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

function PontuacaoTableCell({ real, meta, onClick }) {
  const PontuacaoClassName =
    real < meta * 0.7
      ? 'Pontuacao-baixa'
      : real >= meta * 0.7 && real < meta * 0.95
        ? 'Pontuacao-medio'
        : 'Pontuacao-alta'

  // Render
  return (
    <span className={`Pontuacao ${PontuacaoClassName}`} onClick={onClick}>
      {real}
    </span>
  )
}

const mapToProps = ({
  dashboard: {
    statusOperacoes: { status, pInicial, pFinal },
  },
}) => ({ status, pInicial, pFinal })
export default connect(mapToProps)(withRouter(StatusOperacoesLogisticas))
